module.exports = __webpack_public_path__ + "img/qr_tiktok.8d71114a.png";